export default `
<p>&nbsp;</p>
<table style="height: 57px; width: 15.9889%; border-collapse: collapse; float: left;" border="2">
<tbody>
<tr>
<th style="width: 8.63938%; background-color: #8be084;">
<h2>✓</h2>
</th>
<th style="width: 7.44875%; background-color: #e67777;">
<h2>&nbsp;X</h2>
</th>
<th style="width: 7.07965%; background-color: #fff9a6;">
<h2>&nbsp;?&nbsp;</h2>
</th>
</tr>
</tbody>
</table>
<p style="text-align: left; padding-left: 30px;">&nbsp; &nbsp; &nbsp; To open links in new tab:</p>
<p style="padding-left: 120px; text-align: left;"><strong>&nbsp; &nbsp; &nbsp; Windows</strong>: hold&nbsp;<code>ctrl</code>&nbsp;and click.link</p>
<p style="padding-left: 30px; text-align: left;"><strong>&nbsp; &nbsp; &nbsp; Mac</strong>: I think you hold&nbsp;<code>cmd</code>&nbsp;and click, but there might be a shift or something. Let me know.</p>
<table style="height: 150px; width: 49.4186%; border-collapse: collapse; float: left; border-style: solid;" border="2">
<tbody>
<tr style="height: 16px;">
<td style="width: 10.0981%; height: 16px; border-color: #3f5a91; border-style: solid; text-align: center;" scope="colgroup">
<div style="text-align: center;">Will Test</div>
</td>
<td style="width: 16.941%; height: 16px; border-color: #3f5a91; border-style: solid; text-align: center;" scope="colgroup">
<div><strong>Testing</strong></div>
</td>
<td style="width: 10.2834%; height: 16px; border-color: #3f5a91; border-style: solid; text-align: center;" scope="colgroup">
<div><strong>Test Done</strong></div>
</td>
</tr>
<tr style="height: 30px;">
<td style="height: 26px; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 26px; background-color: #fff9a6; border-color: #3f5a91; border-style: solid; text-align: center;"><a title="https://xing.github.io/wysihtml5/" href="https://xing.github.io/wysihtml5/" target="_blank" rel="noopener">wysihtml5</a>*</td>
<td style="height: 26px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
</tr>
<tr style="height: 29px;">
<td style="height: 26px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 26px; background-color: #8be084; border-color: #3f5a91; border-style: solid; text-align: center;">tinyMCE</td>
<td style="height: 26px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
</tr>
<tr style="height: 29px;">
<td style="height: 26px; background-color: #fff9a6; border-color: #3f5a91; border-style: solid; text-align: center;"><a title="https://docs.sencha.com/extjs/6.2.0/classic/Ext.form.field.HtmlEditor.html" href="https://docs.sencha.com/extjs/6.2.0/classic/Ext.form.field.HtmlEditor.html" target="_blank" rel="noopener">Ext.js HTML Editor</a>*</td>
<td style="height: 26px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 26px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
</tr>
<tr style="height: 32px;">
<td style="height: 29px; background-color: #fff9a6; border-color: #3f5a91; border-style: solid; text-align: center;">TBD</td>
<td style="height: 29px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 29px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
</tr>
<tr style="height: 30px;">
<td style="height: 27px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 27px; border-color: #3f5a91; border-style: solid; text-align: center;">&nbsp;</td>
<td style="height: 27px; background-color: #e67777; border-color: #3f5a91; border-style: solid; text-align: center;">Summernote</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
`;



// WEBPACK FOOTER //
// ./src/components/TextEditor/content.js